import { useHistory } from 'react-router-dom';
import CustomButton from '../CustomButton/CustomButton';
import styles from './index.scss';
import { mainRedirect } from '../../library/Routes';
import { LogoProgramasEducacionais } from 'components/LogoProgramasEducacionais';
import icon404 from './../../assets/images/icon404.gif';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

const rootClassName = styles.rootClassName;

const NotFoundScreen = () => {
  const languageValues = useSelector((state: RootState) => state.languages.languageValues);
  const history = useHistory();

  const toHome = () => {
    history.push(mainRedirect.path);
  };

  return (
    <>
      <div className={rootClassName + '-container-404'}>
        <div className='container-images'>
          <LogoProgramasEducacionais width={200}/>
          <img src={icon404} alt='icone-404' className={'icon-404'} loading='lazy' />
        </div>
        <div className='container-legend'>
          <p>{languageValues.error404}</p>
        </div>
        <CustomButton
          label={languageValues.voltaInicio}
          theme='pufvYellow'
          className={rootClassName + '-main-button'}
          onClick={toHome}
        />
      </div>
    </>
  );
};

export default NotFoundScreen;